import { render, staticRenderFns } from "./DispatchRequests.vue?vue&type=template&id=fc7560e0&"
import script from "./DispatchRequests.vue?vue&type=script&lang=js&"
export * from "./DispatchRequests.vue?vue&type=script&lang=js&"
import style0 from "./DispatchRequests.vue?vue&type=style&index=0&id=fc7560e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports